<section class="section">
  <div class="section-header">
    <div class="section-header-left">
      <h2>Select Time Period</h2>
      <p>Choose your preferred time frame to view PDUFA events</p>
    </div>
    <div class="header-btn">
      <button class="btn btn-primary" (click)="addNewEntry()">
        <i class="fas fa-plus"></i>
        Add New Entry
      </button>
    </div>
  </div>

  <div class="calendar-view">
    <div class="kpi-section">
      <div class="kpi-grid">
        <div class="kpi-card">
          <div class="kpi-icon">
            <i class="fas fa-calendar-day"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{totalPdufas}}</div>
            <div class="kpi-label">Total PDUFAs</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon">
            <i class="fas fa-chart-pie"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{ndaApplications}}</div>
            <div class="kpi-label">NDA Applications</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon">
            <i class="fas fa-edit"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{sndaApplications}}</div>
            <div class="kpi-label">sNDA Applications</div>
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-icon">
            <i class="fas fa-star"></i>
          </div>
          <div class="kpi-content">
            <div class="kpi-value">{{priorityReviews}}</div>
            <div class="kpi-label">Priority Reviews</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="tabs">
    <div class="tabs-header">
      <ul>
        <li class="tab-item" (click)="setTab('monthly')">Monthly</li>
        <li class="tab-item" (click)="setTab('quarterly')">Quarterly</li>
        <li class="tab-item" (click)="setTab('halfyearly')">Half Yearly</li>
        <li class="tab-item" (click)="setTab('yearly')">Yearly</li>
      </ul>
      <div class="year-selector">
        <label for="yearSelect">Select Year:</label>
        <select id="yearSelect" [(ngModel)]="currentYear" (change)="onYearChange()" class="year-dropdown">
          <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="calendar-grid">
    <div class="calendar-section" *ngIf="activeTab === 'monthly'">
      <h3>Monthly</h3>
      <div class="calendar-options">
        <div *ngFor="let option of monthlyOptions" class="calendar-option" [class.current-period]="option.isCurrent"
          (click)="selectPeriod('monthly', option.value)">
          <div class="option-main">{{ option.label }}</div>
        </div>
      </div>
    </div>

    <div class="calendar-section" *ngIf="activeTab === 'quarterly'">
      <h3>Quarterly</h3>
      <div class="calendar-options">
        <div *ngFor="let option of quarterlyOptions" class="calendar-option" [class.current-period]="option.isCurrent"
          (click)="selectPeriod('quarterly', option.value)">
          <div class="option-main">{{ option.label }}</div>
          <div class="option-subtitle">{{ option.subtitle }}</div>
        </div>
      </div>
    </div>

    <div class="calendar-section" *ngIf="activeTab === 'halfyearly'">
      <h3>Half-Yearly</h3>
      <div class="calendar-options">
        <div *ngFor="let option of halfYearlyOptions" class="calendar-option" [class.current-period]="option.isCurrent"
          (click)="selectPeriod('halfyearly', option.value)">
          <div class="option-main">{{ option.label }}</div>
          <div class="option-subtitle">{{ option.subtitle }}</div>
        </div>
      </div>
    </div>

    <div class="calendar-section" *ngIf="activeTab === 'yearly'">
      <h3>Yearly</h3>
      <div class="calendar-options">
        <div *ngFor="let option of yearlyOptions" class="calendar-option" [class.current-period]="option.isCurrent"
          (click)="selectPeriod('yearly', option.value)">
          <div class="option-main">{{ option.label }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="calendar-grid">
    <p-table #dt [value]="filteredCalendarData" scrollDirection="both" [scrollable]="true" [paginator]="true"
      [rows]="10" [showCurrentPageReport]="true" paginatorPosition="both"
      [globalFilterFields]="['company_name','drug_name','application_type','route_of_administration','dosage_form','pdufa_date','active_ingredient']">
      <ng-template pTemplate="caption">
        <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">

          <p-dropdown [options]="therapeuticCategories" [(ngModel)]="selectedTherapeuticArea"
            placeholder="Select Therapeutic Category" (onChange)="onTherapeuticCategoryChange()">
          </p-dropdown>
          <p-dropdown [options]="designationTags" [(ngModel)]="selectedDesignationTag"
            placeholder="Select Designation Tag" (onChange)="onDesignationTagChange()">
          </p-dropdown>
          <p-dropdown [options]="pdufaStatusOptions" [(ngModel)]="selectedPdufaStatus" placeholder="Select PDUFA Status"
            (onChange)="onPdufaStatusChange()">
          </p-dropdown>

          <input type="text" pInputText placeholder="Search..."
            (input)="dt.filterGlobal($event.target.value, 'contains')" style="width: 250px; padding: 6px;" />

          <p-dropdown [options]="publishOptions" [(ngModel)]="selectedPublish" placeholder="Select Publish Status"
            (onChange)="onFilterChange()">
          </p-dropdown>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:100px;" (click)="showModal(rowData)">Brand Name</th>
          <th style="width:100px;">NDA/SNDA</th>
          <th style="width:100px;">Active Ingredient</th>
          <th style="width:100px;">Route of Administration</th>
          <th style="width:100px;">Dosage Form</th>
          <th style="width:100px;">PDUFA Date</th>
          <th style="width:100px;">PDUFA Status</th>
          <th style="width:100px;">Status</th>
          <!-- <th style="width:100px;">View more</th> -->

          <th style="width:80px;">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <td style="text-decoration: underline; cursor: pointer;color: blue;" (click)="showModal(rowData)">
            {{rowData?.drug_name || 'N/A'}}</td>
          <td>{{rowData?.application_type || 'N/A'}}</td>
          <td [innerHTML]="rowData?.active_ingredient"></td>
          <td [innerHTML]="rowData?.route_of_administration || 'N/A'"></td>
          <td [innerHTML]="rowData?.dosage_form || 'N/A'"></td>
          <td>
            {{
            rowData.is_datetime
            ? (rowData.pdufa_date | date:'MMM d, y')
            : (rowData.pdufa_date || 'N/A')
            }}
          </td>
          <td>
            <span class="pdufa-status-badge" [ngClass]="getPdufaStatusClass(rowData?.pdufa_status)">
              {{rowData?.pdufa_status || 'N/A'}}
            </span>
          </td>
          <td>
            <div class="publish-indicator" [class.published]="rowData.publish === true || rowData.publish === 'true'"
              [class.not-published]="rowData.publish !== true && rowData.publish !== 'true'"
              (click)="statusChange(rowData,rowData.publish)">
              <span *ngIf="rowData.publish === true || rowData.publish === 'true'" class="status-text">Published</span>
              <span *ngIf="rowData.publish !== true && rowData.publish !== 'true'" class="status-text">Not
                Published</span>
            </div>
          </td>
          <!-- <td><button class="btn btn-primary" (click)="showModal(rowData)">View more</button></td> -->
          <td>
            <div class="action-buttons">
              <button class="btn btn-primary btn-sm" (click)="editItem(rowData)" title="Edit Entry">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-danger btn-sm" (click)="confirmDelete(rowData)" title="Delete Entry">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<!-- Modal Dialog -->
<p-dialog header="Drug Details" [(visible)]="displayModal" [modal]="true" [style]="{ width: '70vw' }" [closable]="true"
  (onHide)="hideModal()">

  <div class="modal-content" *ngIf="selectedRowData">
    <div class="data-grid">
      <div class="data-row" *ngIf="selectedRowData?.mapped_nda?.brand_name && selectedRowData.type === 'NDA'">
        <div class="data-label">Brand Name:</div>
        <div class="data-value">{{ selectedRowData?.mapped_nda?.brand_name || 'N/A' }}</div>
      </div>
      <div class="data-row">
        <div class="data-label">Company Name:</div>
        <div class="data-value">{{ selectedRowData.company_name || 'N/A' }}</div>
      </div>


      <div class="data-row">
        <div class="data-label">Application Type:</div>
        <div class="data-value">{{ selectedRowData.application_type || 'N/A' }}</div>
      </div>

      <div class="data-row">
        <div class="data-label">Route of Administration:</div>
        <div class="data-value" [innerHTML]="selectedRowData.route_of_administration || 'N/A'"></div>
      </div>

      <div class="data-row">
        <div class="data-label">Dosage Form:</div>
        <div class="data-value" [innerHTML]="selectedRowData.dosage_form || 'N/A'"></div>
      </div>

      <div class="data-row">
        <div class="data-label">PDUFA Date:</div>

        <div class="data-value">
          {{ selectedRowData.is_datetime ?
          (selectedRowData.pdufa_date | date:'MMM d, y') :
          (selectedRowData.pdufa_date || 'N/A') }}
        </div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.drug_name">
        <div class="data-label">Drug Name:</div>
        <div class="data-value">{{ selectedRowData.drug_name || 'N/A' }}</div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.active_ingredient">
        <div class="data-label">Active Ingredient:</div>
        <div class="data-value" [innerHTML]="selectedRowData.active_ingredient || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.categories">
        <div class="data-label">Categories:</div>
        <div class="data-value">
          <span class="badge" *ngFor="let category of (selectedRowData.categories | categoryParser)">
            {{ category }}
          </span>
        </div>
      </div>
      <div class="data-row">
        <div class="data-label">Sub Categories:</div>

        <!-- If condition true show value -->
        <div class="data-value" *ngIf="selectedRowData.sub_categories?.['Existing Active Moiety (EAM)']?.[0] 
            && selectedRowData.sub_categories['Existing Active Moiety (EAM)'][0] !== '' 
            && selectedRowData.sub_categories['Existing Active Moiety (EAM)'][0] !== 'null' 
            && selectedRowData.sub_categories['Existing Active Moiety (EAM)'][0] !== null 
            && selectedRowData.sub_categories['Existing Active Moiety (EAM)'][0] !== undefined; else noData">
          {{ selectedRowData.sub_categories['Existing Active Moiety (EAM)'][0] }}
        </div>

        <!-- Else show N/A -->
        <ng-template #noData>
          <div class="data-value">N/A</div>
        </ng-template>
      </div>

      <div class="data-row" *ngIf="selectedRowData.strength">
        <div class="data-label">Strength:</div>
        <div class="data-value" [innerHTML]="selectedRowData.strength || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.therapeutic_categories">
        <div class="data-label">Therapeutic Categories:</div>
        <div class="data-value">
          <span class="badge" *ngFor="let category of selectedRowData?.therapeutic_categories">{{ category.trim()
            }}</span>
        </div>
        <!-- <div class="data-value">{{ selectedRowData.therapeutic_categories || 'N/A' }}</div> -->
      </div>

      <div class="data-row" *ngIf="selectedRowData.dosing_regimen">
        <div class="data-label">Dosing Regimen:</div>
        <div class="data-value" [innerHTML]="selectedRowData.dosing_regimen || 'N/A'"></div>
      </div>

      <div class="data-row">
        <div class="data-label">PDUFA Comments:</div>
        <div class="data-value" [innerHTML]="selectedRowData.pdufa_comments || 'N/A'"></div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.indication">
        <div class="data-label">Indication:</div>
        <div class="data-value" [innerHTML]="selectedRowData.indication || 'N/A'"></div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.peak_sales">
        <div class="data-label">Peak Sales (USD):</div>
        <div class="data-value">{{ selectedRowData.peak_sales || 'N/A' }}</div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.designation_tags && selectedRowData.designation_tags.length > 0">
        <div class="data-label">Designation Tags:</div>
        <div class="data-value">
          <span class="badge" *ngFor="let tag of selectedRowData.designation_tags">{{ tag }}</span>
        </div>
      </div>
      <div class="data-row"
        *ngIf="selectedRowData.sub_categories && selectedRowData.sub_categories && selectedRowData.sub_categories['Existing Active Moiety (EAM)'] && selectedRowData.sub_categories['Existing Active Moiety (EAM)'].length > 0">
        <div class="data-label">Existing Active Moiety (EAM):</div>
        <div class="data-value">
          <span class="badge" *ngFor="let tag of selectedRowData.sub_categories['Existing Active Moiety (EAM)']">
            {{ tag }}
          </span>
        </div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.comments">
        <div class="data-label">Comments:</div>
        <div class="data-value" [innerHTML]="selectedRowData.comments || 'N/A'"></div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.designations">
        <div class="data-label">FDA Designations:</div>
        <div class="data-value">
          <div *ngIf="selectedRowData.designations && selectedRowData.designations.length > 0; else noDesignations">
            <span *ngFor="let designation of selectedRowData.designations" class="designation-tag">
              {{ designation }}
            </span>
          </div>
          <ng-template #noDesignations>N/A</ng-template>
        </div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.filling_date">
        <div class="data-label">Filling Date:</div>
        <div class="data-value">{{ selectedRowData.filling_date | date:'MMM d, y'}}</div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.acceptance_date">
        <div class="data-label">Acceptance Date:</div>
        <div class="data-value">{{ selectedRowData.acceptance_date | date:'MMM d, y' }}</div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.quarter_year">
        <div class="data-label">Quarter Year:</div>
        <div class="data-value">{{ selectedRowData.quarter_year }}</div>
      </div>


      <div class="data-row" *ngIf="selectedRowData.created_at">
        <div class="data-label">Created At:</div>
        <div class="data-value">{{ selectedRowData.created_at | date:'MMM d, y'}}</div>
      </div>

      <div class="data-row" *ngIf="selectedRowData.updated_at">
        <div class="data-label">Updated At:</div>
        <div class="data-value">{{ selectedRowData.updated_at | date:'MMM d, y' }}</div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.old_indication">
        <div class="data-label">Old Indication:</div>
        <div class="data-value" [innerHTML]="selectedRowData.old_indication || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.old_strength">
        <div class="data-label">Old Strength:</div>
        <div class="data-value" [innerHTML]="selectedRowData.old_strength || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.old_route_of_administration">
        <div class="data-label">Old Route of Administration:</div>
        <div class="data-value" [innerHTML]="selectedRowData.old_route_of_administration || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.old_dosage_form">
        <div class="data-label">Old Dosage Form:</div>
        <div class="data-value" [innerHTML]="selectedRowData.old_dosage_form || 'N/A'"></div>
      </div>
      <div class="data-row" *ngIf="selectedRowData.old_dosage_regimen">
        <div class="data-label">Old Dosage Regimen:</div>
        <div class="data-value" [innerHTML]="selectedRowData.old_dosage_regimen || 'N/A'"></div>
      </div>

    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Close" class="p-button-secondary"
      (click)="hideModal()"></button>
  </p-footer>
</p-dialog>

<!-- Delete Confirmation Dialog -->
<p-dialog header="Confirm Delete" [(visible)]="displayDeleteDialog" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" (onHide)="hideDeleteDialog()">

  <div class="delete-confirmation" *ngIf="itemToDelete">
    <div class="warning-icon">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <div class="confirmation-message">
      <h4>Are you sure you want to delete this entry?</h4>
      <p><strong>Company:</strong> {{ itemToDelete.company_name || 'N/A' }}</p>
      <p><strong>Application Type:</strong> {{ itemToDelete.application_type || 'N/A' }}</p>
      <p><strong>PDUFA Date:</strong> {{ itemToDelete.is_datetime ?
        (itemToDelete.pdufa_date | date:'MMM d, y') :
        (itemToDelete.pdufa_date || 'N/A') }}</p>
      <p class="warning-text">This action cannot be undone.</p>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Cancel" class="p-button-secondary"
      (click)="hideDeleteDialog()"></button>
    <button type="button" pButton icon="pi pi-trash" label="Delete" class="p-button-danger"
      (click)="deleteItem()"></button>
  </p-footer>
</p-dialog>

<!-- Publish Status Confirmation Dialog -->
<p-dialog header="Confirm Publish Status Change" [(visible)]="displayPublishDialog" [modal]="true" [closable]="true"
  [draggable]="false" [resizable]="false" styleClass="p-dialog-sm">

  <div class="publish-confirmation">
    <div class="confirmation-icon">
      <i class="fas fa-question-circle"></i>
    </div>
    <div class="confirmation-message">
      <h4>Are you sure you want to change the publish status?</h4>
      <p><strong>Company:</strong> {{ itemToPublish?.company_name || 'N/A' }}</p>
      <p><strong>Drug Name:</strong> {{ itemToPublish?.drug_name || 'N/A' }}</p>
      <p><strong>Current Status:</strong>
        <span [class.published-text]="itemToPublish?.publish === true || itemToPublish?.publish === 'true'"
          [class.not-published-text]="itemToPublish?.publish !== true && itemToPublish?.publish !== 'true'">
          {{ (itemToPublish?.publish === true || itemToPublish?.publish === 'true') ? 'Published' : 'Not Published' }}
        </span>
      </p>
      <p><strong>New Status:</strong>
        <span [class.published-text]="!(itemToPublish?.publish === true || itemToPublish?.publish === 'true')"
          [class.not-published-text]="itemToPublish?.publish === true || itemToPublish?.publish === 'true'">
          {{ (itemToPublish?.publish === true || itemToPublish?.publish === 'true') ? 'Not Published' : 'Published' }}
        </span>
      </p>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Cancel" class="p-button-secondary"
      (click)="hidePublishDialog()"></button>
    <button type="button" pButton icon="pi pi-check" label="Confirm" class="p-button-success"
      (click)="confirmPublishChange()"></button>
  </p-footer>
</p-dialog>